import styled, { createGlobalStyle } from "styled-components";
import i from "./images/boreal.jpg";

const GlobalStyle = createGlobalStyle`
*{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    scroll-behavior: smooth;
   
    
}
`;

export const Container = styled.div`
  margin: 0 auto;
  width: 97%;
  min-height: 70vh;
  border-radius: 1rem;
  padding-left: 30px;
  padding-right: 30px;
  //background: linear-gradient(rgb(17, 17, 17, 0.5), rgb(17, 17, 17, 0.7)),  url(${i}) no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  @media screen and (max-width: 960px) {
    width: 85%;
  }
`;

export const Button = styled.button`
  border-radius: 20px;
  background: transparent;
  white-space: nowrap;
  padding: ${({ big }) => (big ? "12px 64px" : "10px 20px")};
  font-size: ${({ fontbig }) => (fontbig ? "20px" : "16px")};
  outline: none;
  cursor: pointer;
  font-weight: bold;
  border: 2px solid ${({ light }) => (light ? "#c62828" : "#42a8a1")};
  color: ${({ light }) => (light ? "#e53935" : "#42a8a1")};

  &.active {
    background: #5dc1b9;
    color: #0a0a0a;
    transition: all 0.6s ease-out;
  }

  &:hover {
    transition: all 0.6s ease-out;
    background: ${({ light }) => (light ? "#ef5350" : "#5dc1b9")};
    color: #0a0a0a;
  }

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export default GlobalStyle;
